import React from "react";
import { PAGINATION_PER_PAGE_LIMIT } from "../../helpers/constants";

const PAGE_WINDOW = 2;

export const Pagination = (props) => {
  const {
    onSubmit,
    pagination,
    paramsState,
    limit = PAGINATION_PER_PAGE_LIMIT,
  } = props;

  const totalPages = Math.ceil((pagination?.count || 0) / limit);
  const currentPage = Math.min(
    Math.max(paramsState?.page || 1, 1),
    totalPages || 1,
  );

  if (totalPages <= 1) {
    return null;
  }

  const goToPage = (page) => {
    const safePage = Math.min(Math.max(page, 1), totalPages);
    const offset = (safePage - 1) * limit;
    onSubmit(offset, safePage);
  };

  const getVisiblePages = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const pages = [1];
    const start = Math.max(2, currentPage - PAGE_WINDOW);
    const end = Math.min(totalPages - 1, currentPage + PAGE_WINDOW);

    if (start > 2) {
      pages.push("start-ellipsis");
    }

    for (let page = start; page <= end; page += 1) {
      pages.push(page);
    }

    if (end < totalPages - 1) {
      pages.push("end-ellipsis");
    }

    pages.push(totalPages);

    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <div className="pagination">
      <button
        type="button"
        className="button pagination-button pagination-icon-button"
        onClick={() => goToPage(1)}
        disabled={currentPage === 1}
        aria-label="Prvá strana"
        title="Prvá strana"
      >
        «
      </button>

      <button
        type="button"
        className="button pagination-button pagination-icon-button"
        onClick={() => goToPage(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Predchádzajúca strana"
        title="Predchádzajúca strana"
      >
        ‹
      </button>

      {visiblePages.map((page) =>
        typeof page === "number" ? (
          <button
            type="button"
            key={page}
            className={`button pagination-button ${page === currentPage ? "pagination-button-active" : ""}`}
            disabled={page === currentPage}
            onClick={() => goToPage(page)}
            aria-label={`Strana ${page}`}
            title={`Strana ${page}`}
          >
            {page}
          </button>
        ) : (
          <span key={page} className="pagination-ellipsis">
            …
          </span>
        ),
      )}

      <button
        type="button"
        className="button pagination-button pagination-icon-button"
        onClick={() => goToPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Nasledujúca strana"
        title="Nasledujúca strana"
      >
        ›
      </button>

      <button
        type="button"
        className="button pagination-button pagination-icon-button"
        onClick={() => goToPage(totalPages)}
        disabled={currentPage === totalPages}
        aria-label="Posledná strana"
        title="Posledná strana"
      >
        »
      </button>
    </div>
  );
};
